import { Paper, Typography } from '@mui/material';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import type { LlmCostBucket } from '@/lib/types/dashboard/llmCost';

const axisTickStyle = { fontSize: 11, fill: '#94a3b8' };

const chartTooltipStyle = {
  backgroundColor: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  padding: '8px 12px',
};

const CHART_HEIGHT = 280;

/** 期間バケット別の LLM コスト（USD）。件数とは軸も意味も違うので別グラフにする。 */
export function LlmCostCostChart({ buckets }: { buckets: LlmCostBucket[] }) {
  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" mb={2}>
        期間別コスト
      </Typography>
      <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
        <BarChart data={buckets}>
          <CartesianGrid stroke="#f1f5f9" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="bucket"
            tick={axisTickStyle}
            tickFormatter={(v) => String(v).slice(5)}
            axisLine={{ stroke: '#e2e8f0' }}
          />
          <YAxis
            tick={axisTickStyle}
            tickFormatter={(v) => `$${Number(v).toFixed(2)}`}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={chartTooltipStyle}
            formatter={(value) => `$${Number(value).toFixed(4)}`}
          />
          <Bar dataKey="costUsd" name="コスト (USD)" fill="#6366f1" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}

/** 期間バケット別の実行回数（成功 / 失敗の積み上げ）。離散値なので線ではなく棒で出す。 */
export function LlmCostCountChart({ buckets }: { buckets: LlmCostBucket[] }) {
  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" mb={2}>
        期間別実行回数
      </Typography>
      <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
        <BarChart data={buckets}>
          <CartesianGrid stroke="#f1f5f9" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="bucket"
            tick={axisTickStyle}
            tickFormatter={(v) => String(v).slice(5)}
            axisLine={{ stroke: '#e2e8f0' }}
          />
          <YAxis allowDecimals={false} tick={axisTickStyle} axisLine={false} tickLine={false} />
          <Tooltip
            contentStyle={chartTooltipStyle}
            formatter={(value) => Number(value).toLocaleString()}
          />
          <Legend />
          <Bar dataKey="succeededCount" name="成功" stackId="jobs" fill="#10b981" />
          <Bar
            dataKey="failedCount"
            name="失敗"
            stackId="jobs"
            fill="#ef4444"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}
